/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import { setTitle, closeToaster } from "../../actions/common";
import { NEW_USER } from "../../constants/data";
import {
  actionFetchUserProfileData,
  actionFetchUserIdProfileData,
  actionFetchUserIdProfileDataSuccess,
} from "./actions";
import { Toaster } from "../../components/common/toaster.component";
import UserProfileFormComponent from "./user-profile-form";
import UserProfileTabComponent from "./user-profile-tab";
import { Loader } from "../../components/common/loader.component";

import { Grid, Typography, Container, IconButton } from "@material-ui/core";
import { getLocalDateFromMoment, sortObjectDataByAsending } from "src/utils";
import {
  BoxShadowWrapper,
  SubHeaderWrapper,
  ArrowBackIosIconCustom,
} from "./style";
import "./index.css";

function UserProfileComponent(props: any) {
  const dispatch = useDispatch();
  const useProfileData = useSelector(
    (state: any) => state.userProfile.userProfileData
  );
  const useProfileEditData = useSelector(
    (state: any) => state.userProfile.useProfileEditData
  );
  const countryData = useSelector((state: any) => state.detail.countryData);
  const roleData = useSelector((state: any) => state.common.roleData);
  // const supplierData = useSelector((state: any) => state.common.supplierData);
  const supplierData: any = [];
  // const loginUserData = useSelector((state: any) => state.header.loginUserData);

  const loginUserData: any = {
    id: "000af624-42d5-4a97-9179-149bc75610fe",
    email: "ammartinwala52@outlook.com",
    name: "Ammar",
    lastName: "Tinwala",
    userName: "ammartinwala52@outlook.com",
    role: [
      "Manufacturer",
      "UNICEF SD data focal point",
      "CPP Admin",
      "UNICEF SD Procurement Coordinator",
      "Contacts Administrator",
      "PAHO User",
      "UNICEF Manager",
      "Claims Administrator",
      "Manager",
    ],
    isDeleted: false,
    userSettings: null,
    token:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjAwMGFmNjI0LTQyZDUtNGE5Ny05MTc5LTE0OWJjNzU2MTBmZSIsInJvbGUiOiJNYW51ZmFjdHVyZXIiLCJuYmYiOjE2MTY2NjY3NDksImV4cCI6MTYxNzI3MTU0OSwiaWF0IjoxNjE2NjY2NzQ5fQ.3YHcY5CgAV9BJGF8A0MV4MKv_ng9vIa8kYTRmNbiMI8",
  };
  const toasterMessage = useSelector(
    (state: any) => state.common.toasterMessage
  );
  const isToasterVisible = useSelector(
    (state: any) => state.common.isToasterVisible
  );
  const isLoaderVisible = useSelector(
    (state: any) => state.common.isLoaderVisible
  );
  // const languageSelected = useSelector(
  //   (state: any) => state.header.languageSelected
  // );
  const isSuccess = useSelector((state: any) => state.common.isSuccess);
  const formTitle = useSelector((state: any) => state.common.pageTitle);
  const [showTable, setShowTable] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [editFormValues, setEditFormValues] = useState({});
  const [listCountry, setListCountry] = useState([]);
  const [listRegions, setListRegions] = useState([]);
  const [listRoles, setListRoles] = useState([]);
  const [listSuppliers, setListSuppliers] = useState([]);
  const [counterRegion, setCounterRegion] = useState(0);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [modifiedDate, setModifiedDate] = useState("");
  const [isAddButtonDisable, setIsAddButtonDisable] = useState(true);
  const [firstTimeCall, setFirstTimeCall] = useState(true);

  let listOfCountry: any = [];
  let listOfRegions: any = [];
  let listOfRoles: any = [];
  let listOfSuppliers: any = [];

  const [fieldsRegionArray, setFieldsRegionArray] = useState([]);

  useEffect(() => {
    return () => {
      dispatch(actionFetchUserIdProfileDataSuccess([]));
    };
  }, []);

  useEffect(() => {
    defaultMethodCall();
    setFirstTimeCall(false);
  }, [dispatch]);

  useEffect(() => {
    if (loginUserData) {
      const user = `${loginUserData.email} (${
        loginUserData.name != null ? loginUserData.name : ""
      }  ${loginUserData.lastName != null ? loginUserData.lastName : ""})`;
      setUserId(loginUserData.id);
      setUserName(user);
    }
  }, [loginUserData]);

  useEffect(() => {
    if (Object.keys(useProfileEditData).length) {
      editFormValuesGenrateFieldArray(useProfileEditData);
    }
  }, [useProfileEditData]);

  useEffect(() => {
    populateDataRegionCountry();
  }, [countryData]);

  useEffect(() => {
    populateDataRole();
  }, [roleData]);

  useEffect(() => {
    populateDataSupplier();
  }, [supplierData]);

  const defaultMethodCall = () => {
    const title = "User Profile";
    dispatch(setTitle(title));
    dispatch(actionFetchUserProfileData("-1"));
  };
  // useEffect(() => {
  //   if (firstTimeCall === false) {
  //     dispatch(actionFetchUserProfileData("-1"));
  //   }
  // }, [languageSelected]);

  const showHideTableAndForm = (request: boolean) => {
    setCreatedDate(getLocalDateFromMoment(null));
    setModifiedDate(getLocalDateFromMoment(null));
    setEditFormValues([]);
    setIsEdit(false);
    setShowTable(!request);
    setDefaultRegionArray();
  };

  //call function through the table Edit row value
  const functionEditForm = (rowValues: any) => {
    dispatch(actionFetchUserIdProfileData(rowValues.id));
  };
  
  const editFormValuesGenrateFieldArray = (editRowValues: any) => {    
    if (editRowValues.role) {
      // setFieldsRegionArray([]);
      // let fieldsArray: any = [];
      // setCounterRegion(0);      
        // if (
        //   editRowValues.role.roleName.trim() === NEW_USER.ROLE.ADMIN ||
        //   editRowValues.role.roleName.trim() === NEW_USER.ROLE.FMC ||
        //   editRowValues.role.roleName.trim() === NEW_USER.ROLE.INS ||
        //   editRowValues.role.roleName.trim() === NEW_USER.ROLE.PARTNER ||
        //   editRowValues.role.roleName.trim() === NEW_USER.ROLE.QMU ||
        //   editRowValues.role.roleName.trim() === NEW_USER.ROLE.SOLUTION_OWNER ||
        //   editRowValues.role.roleName.trim() === NEW_USER.ROLE.SOLUTION_TEAM ||
        //   editRowValues.role.roleName.trim() === NEW_USER.ROLE.UNICEF
        // ) {
        //   fieldsArray.push({
        //     roleList: listRoles,
        //     //countryList: listCountry,
        //     //counterRegion: index,
        //     setRoleUser: editRowValues.role,
        //     isRoleRequired: true,
        //   });
        // }
      // setFieldsRegionArray(fieldsArray);
      // setCounterRegion((prevCounter) => editRowValues.userRoleMapping.length);
    } else {
      setDefaultRegionArray();
    }

    setEditFormValues(editRowValues.data);
    setIsEdit(true);
    setShowTable(false);
  };

  const populateDataRegionCountry = () => {
    if (countryData && countryData.length) {
      countryData.map((country: any) => {
        listOfCountry.push({
          key: country.id,
          id: country.id,
          label: country.name,
          region: country.region,
        });
        if (listOfRegions.length === 0) {
          listOfRegions.push({
            key: country.region,
            id: country.region,
            label: country.region,
          });
        } else if (listOfRegions.length) {
          const filterListRegion = listOfRegions.filter(
            (reg: any) => reg.id === country.region
          );
          if (filterListRegion.length == 0) {
            listOfRegions.push({
              key: country.region,
              id: country.region,
              label: country.region,
            });
          }
        }
      });
      listOfCountry = sortObjectDataByAsending(listOfCountry, "label");
      listOfRegions = sortObjectDataByAsending(listOfRegions, "label");
      setListCountry(listOfCountry);
      setListRegions(listOfRegions);
    }
  };

  const populateDataRole = () => {
    if (roleData && roleData.length) {
      roleData.map((role: any) => {
        listOfRoles.push({
          key: role.id,
          id: role.id,
          label: role.name,
        });
      });

      setListRoles(listOfRoles);
      setIsAddButtonDisable(false);
    } else {
      setIsAddButtonDisable(true);
    }
  };

  const populateDataSupplier = () => {
    if (supplierData && supplierData.length) {
      supplierData.map((supplier: any) => {
        listOfSuppliers.push({
          key: supplier.id,
          id: supplier.id,
          label: supplier.name,
        });
      });

      setListSuppliers(listOfSuppliers);
    }
  };

  const setDefaultRegionArray = () => {
    setFieldsRegionArray([]);
    let values: any = [];

    setCounterRegion(0);
    values.push({
      roleList: listRoles,
      countryList: [],
      counterRegion: 0,
      setRoleUser: [],
    });
    setFieldsRegionArray(values);
    setCounterRegion(1);
  };
  const closeToasterFun = () => {
    dispatch(closeToaster());
  };
  return (
    <Container>
      <Toaster
        message={toasterMessage}
        open={isToasterVisible}
        close={closeToasterFun}
        success={isSuccess}
      />
      <Loader visible={isLoaderVisible} />
      {showTable ? (
        <>
          <SubHeaderWrapper>
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                <Typography component="span" className="common-label">
                  Manage Users
                </Typography>
              </Grid>
              <Grid item>
                <Grid container spacing={2} justify="flex-end">
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => showHideTableAndForm(showTable)}
                      // disabled={isAddButtonDisable}
                    >
                      Create New User
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </SubHeaderWrapper>
          <BoxShadowWrapper>
            <UserProfileTabComponent
              useProfileData={useProfileData}
              formTitle={formTitle}
              functionEditForm={functionEditForm}
              showHideTableAndForm={showHideTableAndForm}
            ></UserProfileTabComponent>
          </BoxShadowWrapper>
        </>
      ) : (
        <>
          <SubHeaderWrapper>
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <Grid container alignItems="center">
                  <Grid item>
                    <IconButton
                      className="padding10"
                      color="default"
                      onClick={() => showHideTableAndForm(showTable)}
                    >
                      <ArrowBackIosIconCustom />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <Typography
                      component="span"
                      className="common-label padding10-5"
                    >
                      {isEdit ? "Edit" : "Add"} User Profile
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </SubHeaderWrapper>
          <BoxShadowWrapper>
            <UserProfileFormComponent
              useProfileData={useProfileData}
              formTitle={formTitle}
              editFormValues={editFormValues}
              isEdit={isEdit}
              showHideTableAndForm={showHideTableAndForm}
              countryData={countryData}
              roleData={roleData}
              listRegions={listRegions}
              listRoles={listRoles}
              fieldsRegionArray={fieldsRegionArray}
              listCountry={listCountry}
              counterRegion={counterRegion}
              setCounterRegion={setCounterRegion}
              setFieldsRegionArray={setFieldsRegionArray}
              closeToasterFun={closeToasterFun}
              userName={userName}
              userId={userId}
              createdDate={createdDate}
              modifiedDate={modifiedDate}
              listSuppliers={listSuppliers}
            ></UserProfileFormComponent>
          </BoxShadowWrapper>
        </>
      )}
    </Container>
  );
}

export default UserProfileComponent;
